<template>
    <div class="tab-container">
        <svg-observer></svg-observer>
        <div v-if="showAccordionNav"
             class="tabs-full"
             :class="{'d-hide': isMixedMode, 't-hide': isMixedMode}"
             @click="toggle"
        >
            <div class="tab" :class="{'tab-active': isActive}">
                <span class="icon symbol" v-if="icon">
                    <svg class="icon">
                        <use :xlink:href="'/images/icon/'+icon+'.svg#icon'"></use>
                    </svg>
                </span>

                <span class="icon arrow" v-show="isActive"><svg class="icon" data-src="/images/icon/expand_less.svg#icon"></svg></span>
                <span class="icon arrow" v-show="!isActive"><svg class="icon" data-src="/images/icon/expand_more.svg#icon"></svg></span>

                <div class="txt">{{ title }}</div>
            </div>
        </div>

        <div class="tab-inner" :class="{'tab-inner-active': isActive}">
            <slot :isActive="isActive"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Tab',

        props: {
            title: { type: String, required: true },
            icon: { type: String },
            hash: { type: String },
            selected: { type: Boolean, default: false },
            right: { type: Boolean, default: false },
            showIcon: { type: Boolean, default: true },
            showTitle: { type: Boolean, default: true },
        },

        data() {
            return {
                isActive: this.selected,
            };
        },

        computed: {
            isMixedMode() {
                return this.$parent.isMixedMode;
            },
            showAccordionNav() {
                return this.$parent.showAccordionNav;
            }
        },

        methods: {
            toggle() {
                this.$parent.selectTab(this.isActive ? null : this);
            }
        },
    }
</script>

